import React from 'react';
import { Link, Typography } from '@mui/material';

export const ESG_DYNAMICS_URL = 'https://esg-dynamics.com';

export function EsgDynamicsLink({ children = 'ESG Dynamics', sx, ...props }) {
  return (
    <Link
      href={ESG_DYNAMICS_URL}
      underline="hover"
      target="_blank"
      rel="noopener noreferrer"
      sx={sx}
      {...props}
    >
      {children}
    </Link>
  );
}

const ProductOfBrand = ({ variant = 'body2', color = 'text.secondary', linkColor = 'inherit', sx, onClick }) => (
  <Typography variant={variant} color={color} component="p" sx={sx} onClick={onClick}>
    A product of{' '}
    <EsgDynamicsLink color={linkColor} />
  </Typography>
);

export default ProductOfBrand;
